/**
 * @generated SignedSource<<abff0b014f74822f10cef5e5ea4402c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type queriesPackageReportRemindersSubscription$variables = {
  property_batch_id: number;
};
export type queriesPackageReportRemindersSubscription$data = {
  readonly sys_reminders_aggregate: {
    readonly aggregate: {
      readonly count: number;
    } | null;
  };
};
export type queriesPackageReportRemindersSubscription = {
  response: queriesPackageReportRemindersSubscription$data;
  variables: queriesPackageReportRemindersSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_batch_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "property_batch_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_batch_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_reminders_aggregate",
    "kind": "LinkedField",
    "name": "sys_reminders_aggregate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_reminders_aggregate_fields",
        "kind": "LinkedField",
        "name": "aggregate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queriesPackageReportRemindersSubscription",
    "selections": (v1/*: any*/),
    "type": "subscription_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queriesPackageReportRemindersSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a649343244433b4a1b48cdd7e16deb7e",
    "id": null,
    "metadata": {},
    "name": "queriesPackageReportRemindersSubscription",
    "operationKind": "subscription",
    "text": "subscription queriesPackageReportRemindersSubscription(\n  $property_batch_id: Int!\n) {\n  sys_reminders_aggregate(where: {property_batch_id: {_eq: $property_batch_id}}) {\n    aggregate {\n      count\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "139aa953482c77bf97a233b34491f64a";

export default node;
